import React from "react"

import HeaderUI from "@ecom/ui/components/Header/HeaderContainer"

import useMediaQuery from "@material-ui/core/useMediaQuery"

import { useObserver } from "../../../hooks/useObserver"

import { RightSection } from "./RightSection/RightSection"

import { pushToDataLayerOnce } from "../../../helpers/pushToDataLayerOnce"

import * as styles from "./Header.module.scss"
import { HeaderProps } from "./types"
import { RedHalvaWithSovcombank } from "../../Headers/Logos"

const options = {
  rootMargin: "0px 0px -50% 0px",
  threshold: 0,
}

const classes = {
  logo: styles.logo,
  navigation: styles.navigation,
  header: styles.red,
}

export const Header = ({
  children,
  buttonText = "Оформить карту",
  isHint = false,
  isCta = false,
  noRightSection = false,
  noShadow = true,
  countDownTime = 1799999,
  withNav = false,
  hint,
  hintTitle,
  background,
  withButton = true,
  isCountdown = false,
  redirectLink = "https://halvacard.ru/",
  logoClick = true,
  isVisibleBlockTopCta = false,
}: HeaderProps) => {
  const isTab = useMediaQuery("(min-width:600px)")
  const isDesktop = useMediaQuery("(min-width:960px)")
  const isFormFocus = useObserver(["app"], options)
  const sticky = isTab && (isDesktop ? true : !isFormFocus) && !isVisibleBlockTopCta

  const onLogoClick = () => {
    pushToDataLayerOnce("logo-header", { event: "buttonClick", name: "logo-header" })
    window.open(redirectLink, "_blank")
  }

  const rightSection = (
    <RightSection
      countDownTime={countDownTime}
      isHint={isHint}
      isCta={isCta}
      buttonText={buttonText}
      hint={hint}
      background={background}
      hintTitle={hintTitle}
      isCountdown={isCountdown}
    />
  )

  return (
    <HeaderUI
      withNav={withNav}
      withButton={withButton}
      withPhone={false}
      right={countDownTime > 0 && !noRightSection && rightSection}
      onLogoClick={logoClick && onLogoClick}
      noShadow={noShadow}
      Logo={RedHalvaWithSovcombank}
      sticky={sticky}
      classes={classes}
    >
      {children}
    </HeaderUI>
  )
}
